// extracted by mini-css-extract-plugin
export default {"spin":"loader_spin__u99fp","loaderContainer":"loader_loaderContainer__8xub0"};